import { mountComponent } from '../util/mount';
import {
    DiscountId,
    HtmlId,
} from '../enums/elementId';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import {
    createPromotionalCard,
    PROMOTIONAL_CARD_LABEL_CLASSNAME,
    PROMOTIONAL_CARD_SUBLABEL_CLASSNAME,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import { IFormSelectionControlProperties } from '@vfde-brix/ws10/form-selection-control';
import { CashbackData } from '../interface';
import {
    getCMSConfig,
    getPsPromoCardData,
} from '../util/cms';
import { formatPrice } from '../util/formatter';
import { getCookie } from '@vfde-sails/utils';
import { Cookies } from '../enum';

/**
 * Create Brix Promotional Card component.
 *
 * @param id - Wrapper ID of the element.
 * @returns Promotional card component or null if
 * the element with the given ID is not found.
 */
export const mountPromotionalCard = (id: HtmlId) =>
    mountComponent(id, createPromotionalCard, NO_PATTERN_BUSINESS_LOGIC);

/**
 * Updates the PromotionalCard component used for showing discounts on the landing page.
 * Also re-mounts the button that opens the overlay with the discounts inside.
 *
 * @param {PromotionalCard | null} comp - component to update
 * @param {DiscountData} data - contains text to show
 * @param {Function} openDiscounts - callback to open overlay with discounts
 */
export const updateCashbackPromotionCard = (
    comp: PromotionalCard | null,
    data: CashbackData | undefined,
    disable?: boolean,
    checked?: boolean,
) => {
    // Early return if component is null
    if (!comp || !data) {
        return;
    }

    const props = comp.getProperties();

    props.stdLabel = '';
    props.txtSublabel = data.label;

    // Handle form selection control for cashback
    if (data.item) {
        const checkboxData: IFormSelectionControlProperties = {
            stdGroupName: 'cashback',
            optType: 'checkbox',
            business: NO_PATTERN_BUSINESS_LOGIC,
            items: [{
                txtLabelText: data.item.label,
                stdValue: data.item.value,
                stdID: data.item.id,
                ...(disable && { optState: 'disabled' }),
            }],
        };
        props.containerFormSelectionControl = checkboxData;
    }
    else {
        props.containerFormSelectionControl = undefined;
    }

    comp.update(props);

    const parentElement = document.getElementById(DiscountId.CASH_BACK);

    if (parentElement) {
        const cardHeadline = parentElement.getElementsByClassName(PROMOTIONAL_CARD_LABEL_CLASSNAME)[0];

        if (cardHeadline) {
            cardHeadline.innerHTML = data.headline;
        }
    }

    if (checked && data.item) {
        const checkbox = document.getElementById(data.item.id) as HTMLInputElement;
        checkbox.checked = true;
    }
};

/**
 * Updates the innerHTML of the ResidentPlus Promo Card
 * Note: Workaround until the Promo Card update is not fixed
 */
export const updateResidentPlusInnerHTML = (price?: number) => {
    if (!price) {
        return;
    }

    const cardEl = document.getElementById(DiscountId.RESIDENT_PLUS_CARD);
    const [labelEl] = cardEl?.getElementsByClassName(PROMOTIONAL_CARD_LABEL_CLASSNAME) || [];
    const [subLabelEl] = cardEl?.getElementsByClassName(PROMOTIONAL_CARD_SUBLABEL_CLASSNAME) || [];

    if (!labelEl || !subLabelEl) {
        return;
    }

    const { label, subLabel } = getCMSConfig().residentPlusCard;

    labelEl.innerHTML = formatPrice(label, Math.abs(price));
    subLabelEl.innerHTML = formatPrice(subLabel, Math.abs(price));
};

/**
 * update Ps Promotion Card
 */
export const updatePsPromotionCard = (
    comp: PromotionalCard | null,
) => {
    const config = getPsPromoCardData();

    // Early return if component is null
    if (!comp || !config) {
        return;
    }

    const props = comp.getProperties();

    props.stdLabel = '';
    props.txtSublabel = config.label;

    comp.update(props);

    const parentElement = document.getElementById(DiscountId.PLAYSTATION_PROMO_CARD);

    if (parentElement) {
        const cardHeadline = parentElement.getElementsByClassName(PROMOTIONAL_CARD_LABEL_CLASSNAME)[0];

        if (cardHeadline) {
            cardHeadline.innerHTML = config.headline;
        }
    }
};
